const Catalog = 'Catalog';

export const UPDATE_CATALOG_ITEM_REQUEST = `${Catalog}/UPDATE_CATALOG_ITEM_REQUEST`;
export const UPDATE_CATALOG_ITEM_RESPONSE = `${Catalog}/UPDATE_CATALOG_ITEM_RESPONSE`;
export const UPDATE_CATALOG_ITEM_ERROR = `${Catalog}/UPDATE_CATALOG_ITEM_ERROR`;

export const UPDATE_FIELDS_AND_CATALOG_ITEM_REQUEST = `${Catalog}/UPDATE_FIELDS_AND_CATALOG_ITEM_REQUEST`;
export const UPDATE_FIELDS_AND_CATALOG_ITEM_RESPONSE = `${Catalog}/UPDATE_FIELDS_AND_CATALOG_ITEM_RESPONSE`;
export const UPDATE_FIELDS_AND_CATALOG_ITEM_ERROR = `${Catalog}/UPDATE_FIELDS_AND_CATALOG_ITEM_ERROR`;

export const UPDATE_BULK_CATALOG_ITEMS_REQUEST = `${Catalog}/UPDATE_BULK_CATALOG_ITEMS_REQUEST`;
export const UPDATE_BULK_CATALOG_ITEMS_RESPONSE = `${Catalog}/UPDATE_BULK_CATALOG_ITEMS_RESPONSE`;
export const UPDATE_BULK_CATALOG_ITEMS_ERROR = `${Catalog}/UPDATE_BULK_CATALOG_ITEMS_ERROR`;

export const UPDATE_FIELDS_AND_BULK_CATALOG_ITEMS_REQUEST = `${Catalog}/UPDATE_FIELDS_AND_BULK_CATALOG_ITEMS_REQUEST`;
export const UPDATE_FIELDS_AND_BULK_CATALOG_ITEMS_RESPONSE = `${Catalog}/UPDATE_FIELDS_AND_BULK_CATALOG_ITEMS_RESPONSE`;
export const UPDATE_FIELDS_AND_BULK_CATALOG_ITEMS_ERROR = `${Catalog}/UPDATE_FIELDS_AND_BULK_CATALOG_ITEMS_ERROR`;

export const CSV_KEY_MISSING = `${Catalog}/CSV_KEY_MISSING`;
export const SKIP_FIELD_DEFINITION = `${Catalog}/SKIP_FIELD_DEFINITION`;
export const SKIP_FIELD_DEFINITION_AND_UPLOAD_ONLY = `${Catalog}/SKIP_FIELD_DEFINITION_AND_UPLOAD_ONLY`;
export const UPLOAD_SIZE_EXCEEDED = `${Catalog}/UPLOAD_SIZE_EXCEEDED`;
